export default "__VITE_ASSET__Ba_34W75__"